import classNames from "classnames";
import { useMemo } from "react";

import MultiReferenceRecord from "../../../Records/References/ReferencesComponents/MultiReferenceRecord";
import useQueriedRecords from "../../../../api/api-hooks/records/useQueriedRecords";
import useUser from "../../../../api/api-hooks/auth/useUser";
import { BrieGPTProject } from "../useBrieGPTItems";

const emptyFunction = () => {};

function MembersList({ project }: { project: BrieGPTProject }) {
  const { user } = useUser();
  const rawMembers = useMemo(() => {
    // In case there are no members and the owner is not in it.
    if (!project?.Members) {
      return [
        {
          Member: {
            id: project?.CreatedBy,
            _RecordName: user?._RecordName,
            _ModuleAPIName: "Contacts",
          },
          Owner: true,
        },
      ];
    }

    return project?.Members;
  }, [project?.Members]);

  const query = useMemo(() => {
    return {
      Fields: ["id", "_RecordName", "Email", "_TenantUser"],
      Filters: [
        {
          Group: true,
          Filters: [
            {
              Field: "id",
              Method: "in",
              Value: rawMembers?.map((m) => m.Member.id) || [],
            },
          ],
        },
      ],
    };
  }, [rawMembers]);

  const { records: members, recordsLoading } = useQueriedRecords({
    moduleAPIName: "Contacts",
    query,
    disabled: !project,
  });

  return (
    <>
      <div
        className={classNames(
          "tw:relative tw:w-full",
          !recordsLoading ? "tw:mt-3" : ""
        )}
      >
        {recordsLoading ? (
          <div className="skeleton tw:w-24 tw:h-6 mt:-1" />
        ) : (
          <MultiReferenceRecord
            onOpen={emptyFunction}
            onView={emptyFunction}
            existingValue={members}
            tableView={true}
            metadataField={null}
            metadataFieldType={null}
            maxValuesDisplayed={10}
          />
        )}
      </div>
    </>
  );
}

export default MembersList;
